import { render, staticRenderFns } from "./DeliveryInstruction.vue?vue&type=template&id=4bc3bfd4&scoped=true&lang=pug"
import script from "./DeliveryInstruction.vue?vue&type=script&lang=js"
export * from "./DeliveryInstruction.vue?vue&type=script&lang=js"
import style0 from "./DeliveryInstruction.vue?vue&type=style&index=0&id=4bc3bfd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc3bfd4",
  null
  
)

export default component.exports